/**
 *
 * Asynchronously loads the component for CheckLogin
 *
 */

import { lazyLoad } from 'utils/loadable';

export const CheckLogin = lazyLoad(
  () => import('./index'),
  module => module.CheckLogin
);
